import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ManageRolePage from "./ManageRolePage";
import RoleListingPage from "./RoleListingPage";
import { withPermission, Roles } from "../../../util/PermissionProvider";

export default function PermissionManagementPage(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(RoleListingPage, [Roles.SUPERADMIN])}
      />
      <Route
        path={`${match.url}/manage/:role`}
        component={withPermission(ManageRolePage, [Roles.SUPERADMIN])}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
